import { useEffect, useRef, useState } from 'react';
import { getSystemNow } from '../models/timeAPI';

export function useSystemNow({ refreshMs = 5000 } = {}) {
  const [now, setNow] = useState(null); // { iso, unix }
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const timerRef = useRef(null);

  const load = async () => {
    try {
      console.log('🔄 useSystemNow: Fetching server time from API...');
      const data = await getSystemNow();
      console.log('✅ useSystemNow: Received server time:', data);
      setNow(data);
      setError(null);
    } catch (e) {
      console.error('❌ useSystemNow: Failed to fetch server time:', e);
      setError(e?.message || 'Failed to load time');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    timerRef.current = setInterval(load, refreshMs);
    return () => clearInterval(timerRef.current);
  }, [refreshMs]);

  return { now, loading, error, reload: load };
}

export default useSystemNow;


